import get from 'lodash/get';
import { PATTERNS } from '../../constants/validations';
import { INSURANCE_FLOW_TYPE } from '../../constants/insurance-flow-type';
import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../constants/formFields';
import { INITIAL_INSURANCE_FORM_STATE } from '../../constants/insurance/initial-insurance-form-state';

import { removeNonNumeric } from '../removeNonNumeric';

const {
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  DOB,
  DO_NOT_HAVE_INSURANCE,
  FIRST_NAME,
  GENDER,
  GROUP_NUMBER,
  HEALTH_PLAN,
  INSURANCE_RELATION_ID,
  LAST_NAME,
  MEMBER_ID,
  PHONE_NUMBER,
  POSTAL_CODE,
  PRIMARY_SUBSCRIBER,
  STATE,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

const convertFromBEDateFormatToDatePickerFormat = dateStr => {
  if (!PATTERNS.YYYY_MM_DD_REGEX.test(dateStr)) return null;

  const [year, month, day] = dateStr.split('-');
  return `${month}-${day}-${year}`;
};

export const getInitialInsuranceFormValues = ({
  insurance,
  isAdditionalInsurance,
  flowType, // by default is undefined
}) => {
  const {
    payer,
    memberId,
    groupNumber,
    primarySubscriber,
    id: insuranceId,
    frontSide,
    backSide,
    isPrimarySubscriber,
  } = insurance;

  const { id, name } = { ...payer };

  const {
    address1,
    address2,
    city,
    dob,
    firstName,
    gender,
    insuranceRelationId,
    lastName,
    phoneNumber,
    postalCode,
    state,
  } = {
    ...primarySubscriber,
  };

  const isToDoFlowType = flowType === INSURANCE_FLOW_TYPE.TO_DO;

  const healthPlanValue =
    id && name
      ? { id, label: name, value: name }
      : INITIAL_INSURANCE_FORM_STATE[HEALTH_PLAN];

  const phoneNumberValue =
    (phoneNumber && removeNonNumeric(phoneNumber)) ||
    INITIAL_INSURANCE_FORM_STATE[PHONE_NUMBER];

  const dobValue =
    (dob && convertFromBEDateFormatToDatePickerFormat(dob)) ||
    INITIAL_INSURANCE_FORM_STATE[DOB];

  const hasInsuranceValue = !isAdditionalInsurance
    ? { [DO_NOT_HAVE_INSURANCE]: insurance.skipInsurance }
    : null;

  const primarySubscriberValue =
    isAdditionalInsurance || isToDoFlowType
      ? isPrimarySubscriber
      : !(primarySubscriber && Object.values(primarySubscriber).length > 0);

  const additionalInsuranceProps = { id: insuranceId, frontSide, backSide };

  return {
    ...hasInsuranceValue,
    ...additionalInsuranceProps,
    [HEALTH_PLAN]: healthPlanValue,
    [MEMBER_ID]: memberId || INITIAL_INSURANCE_FORM_STATE[MEMBER_ID],
    [GROUP_NUMBER]: groupNumber || INITIAL_INSURANCE_FORM_STATE[GROUP_NUMBER],
    [PRIMARY_SUBSCRIBER]: primarySubscriberValue,
    [FIRST_NAME]: firstName || INITIAL_INSURANCE_FORM_STATE[FIRST_NAME],
    [LAST_NAME]: lastName || INITIAL_INSURANCE_FORM_STATE[LAST_NAME],
    [DOB]: dobValue,
    [PHONE_NUMBER]: phoneNumberValue,
    [ADDRESS_1]: address1 || INITIAL_INSURANCE_FORM_STATE[ADDRESS_1],
    [ADDRESS_2]: address2 || INITIAL_INSURANCE_FORM_STATE[ADDRESS_2],
    [CITY]: city || INITIAL_INSURANCE_FORM_STATE[CITY],
    [STATE]: state || INITIAL_INSURANCE_FORM_STATE[STATE],
    [POSTAL_CODE]: postalCode || INITIAL_INSURANCE_FORM_STATE[POSTAL_CODE],
    [GENDER]: gender || INITIAL_INSURANCE_FORM_STATE[GENDER],
    [INSURANCE_RELATION_ID]:
      insuranceRelationId ||
      INITIAL_INSURANCE_FORM_STATE[INSURANCE_RELATION_ID],
  };
};

export const validateInsuranceFormFields = ({
  formState,
  hideInsuranceRelationFieldOrInfo = false,
}) => {
  const healthPlan = get(formState, 'healthPlan', null);
  const isPlanNotListedSelected = Boolean(healthPlan && !healthPlan.id);

  if (formState[PRIMARY_SUBSCRIBER]) {
    if (isPlanNotListedSelected) {
      return true;
    }
    return [formState[MEMBER_ID], formState[HEALTH_PLAN]].every(Boolean);
  }

  const checkIsInsuranceRelationFieldFilled = () => {
    // Empty array used to ensure the field is considered filled
    if (hideInsuranceRelationFieldOrInfo) return [];

    return formState[INSURANCE_RELATION_ID];
  };

  return [
    ...(isPlanNotListedSelected ? [] : [formState[MEMBER_ID]]),
    ...(isPlanNotListedSelected ? [] : [formState[HEALTH_PLAN]]),
    formState[FIRST_NAME],
    formState[LAST_NAME],
    formState[DOB],
    formState[ADDRESS_1],
    formState[CITY],
    formState[STATE],
    formState[PHONE_NUMBER],
    formState[POSTAL_CODE],
    formState[GENDER],
    checkIsInsuranceRelationFieldFilled(),
  ].every(Boolean);
};



// WEBPACK FOOTER //
// ./src/utils/manage-insurances/get-initial-insurance-form-values.js